// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningFilledSvg from "@fishx/icons-svg/es/asn/WarningFilled";
import FishxIcon from '../components/FishxIcon';

var WarningFilled = function WarningFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningFilledSvg
  }));
};

WarningFilled.displayName = 'WarningFilled';
export default React.forwardRef(WarningFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WarningFilled.js
// module id = 4381
// module chunks = 0